import React, { useEffect, useState } from 'react';
import { styled } from '@compiled/react';
import Page from '@atlaskit/page';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import ErrorState from '@atlassian/jira-admin-pages-common/src/ui/error-state/index.tsx';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { useContactAdministratorDetails } from '../services/fetch-contact-admin-details/index.tsx';
import ContactAdminForm from './contact-admin-form/index.tsx';
import messages from './messages.tsx';
import PreFormatMessage from './pre-formatted-html/index.tsx';

const CONTACT_ADMINT_PACKAGE_NAME = 'jiraAdminPagesContactAdministrator';

const ContactAdministrator = () => {
	const [pageCrash, updatePageCrash] = useState(false);
	const { loading, error, data, fetchContactAdminDetails } = useContactAdministratorDetails();
	useEffect(() => {
		// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
		fetchContactAdminDetails();
	}, [fetchContactAdminDetails]);
	useEffect(() => {
		if (error) {
			trackFetchErrors({
				error,
				id: 'fetchContactAdminDetails',
				packageName: CONTACT_ADMINT_PACKAGE_NAME,
			});
		}
	}, [error]);
	const { formatMessage } = useIntl();
	const { isEnabled, message, to, replyTo, reCaptchaSharedKey } = data;
	if (error || pageCrash) {
		return <ErrorState />;
	}
	if (loading) {
		return null;
	}
	const appearance = isEnabled ? 'information' : 'warning';
	return (
		<Page>
			<Container>
				<PageHeader>{formatMessage(messages.pageHeader)}</PageHeader>
				{message !== null && message && (
					<FormContainer>
						<SectionMessage
							appearance={appearance}
							testId="admin-pages-contact-administrator.ui.section-message"
						>
							<PreFormatMessage text={message || ''} />
						</SectionMessage>
					</FormContainer>
				)}
				{isEnabled && (
					<FormContainer>
						<ContactAdminForm
							to={to || ''}
							replyTo={replyTo || ''}
							updatePageCrash={updatePageCrash}
							reCaptchaSharedKey={reCaptchaSharedKey}
							infoBannerMessage={message || ''}
						/>
					</FormContainer>
				)}
			</Container>
		</Page>
	);
};
export default ContactAdministrator;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	maxWidth: '800px',
	marginTop: token('space.400', '32px'),
	marginRight: 'auto',
	marginBottom: token('space.400', '32px'),
	marginLeft: 'auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageHeader = styled.h2({
	marginBottom: token('space.400', '32px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FormContainer = styled.div({
	marginTop: token('space.250', '20px'),
	maxWidth: '600px',
});
